module.exports = __webpack_public_path__ + "static/grandetable-card-3229519c8ae4ed87549087f5052ed7a6.png";